import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const PRICING_PLAN_API = ShipbobAppSettings.shipbobV2Api

class ShippingOptionsServiceInternal {
  urls () {
    return {
      getShippingOptions: PRICING_PLAN_API + '/api/viewPricingPlan/getShipOptionSelections'
    }
  }

  handleGetShippingOptionsError = (res) => {
    toastr['error']('Unable to retrieve shipping options')
  }

  async getShippingOptions () {
    const request = {
      Url: `${this.urls().getShippingOptions}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetShippingOptionsError, true)
  }
}

export const ShippingOptionsService = new ShippingOptionsServiceInternal()
